var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstaShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.649902,
    y: 1.17871,
    width: 65.5,
    height: 65.5,
    rx: 32.75,
    fill: "#FF1FCC",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.649902,
    y: 1.17871,
    width: 65.5,
    height: 65.5,
    rx: 32.75,
    stroke: "#E6E6E6",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6316_2939)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 18.7451H18V50.7451H50V18.7451Z",
    fill: "url(#paint0_radial_6316_2939)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 18.7451H18V50.7451H50V18.7451Z",
    fill: "url(#paint1_radial_6316_2939)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 25.7331C36.9157 25.7331 37.3133 25.7331 38.506 25.7331C39.5663 25.7331 40.0964 25.9981 40.494 26.1307C41.0241 26.3957 41.4217 26.5283 41.8193 26.9258C42.2169 27.3234 42.4819 27.721 42.6145 28.2511C42.747 28.6487 42.8795 29.1789 43.012 30.2391C43.012 31.4319 43.012 31.6969 43.012 34.7451C43.012 37.7933 43.012 38.0584 43.012 39.2511C43.012 40.3114 42.747 40.8415 42.6145 41.2391C42.3494 41.7692 42.2169 42.1668 41.8193 42.5644C41.4217 42.962 41.0241 43.227 40.494 43.3596C40.0964 43.4921 39.5663 43.6246 38.506 43.7572C37.3133 43.7572 37.0482 43.7572 34 43.7572C30.9518 43.7572 30.6867 43.7572 29.494 43.7572C28.4337 43.7572 27.9036 43.4921 27.506 43.3596C26.9759 43.0945 26.5783 42.962 26.1807 42.5644C25.7831 42.1668 25.5181 41.7692 25.3855 41.2391C25.253 40.8415 25.1205 40.3114 24.988 39.2511C24.988 38.0584 24.988 37.7933 24.988 34.7451C24.988 31.6969 24.988 31.4319 24.988 30.2391C24.988 29.1789 25.253 28.6487 25.3855 28.2511C25.6506 27.721 25.7831 27.3234 26.1807 26.9258C26.5783 26.5283 26.9759 26.2632 27.506 26.1307C27.9036 25.9981 28.4337 25.8656 29.494 25.7331C30.6867 25.7331 31.0843 25.7331 34 25.7331ZM34 23.7451C30.9518 23.7451 30.6867 23.7451 29.494 23.7451C28.3012 23.7451 27.506 24.0102 26.8434 24.2752C26.1807 24.5403 25.5181 24.9379 24.8554 25.6005C24.1928 26.2632 23.9277 26.7933 23.5301 27.5885C23.2651 28.2511 23.1325 29.0463 23 30.2391C23 31.4319 23 31.8295 23 34.7451C23 37.7933 23 38.0584 23 39.2511C23 40.4439 23.2651 41.2391 23.5301 41.9017C23.7952 42.5644 24.1928 43.227 24.8554 43.8897C25.5181 44.5523 26.0482 44.8174 26.8434 45.215C27.506 45.4801 28.3012 45.6126 29.494 45.7451C30.6867 45.7451 31.0843 45.7451 34 45.7451C36.9157 45.7451 37.3133 45.7451 38.506 45.7451C39.6988 45.7451 40.494 45.4801 41.1566 45.215C41.8193 44.9499 42.4819 44.5523 43.1446 43.8897C43.8072 43.227 44.0723 42.6969 44.4699 41.9017C44.7349 41.2391 44.8675 40.4439 45 39.2511C45 38.0584 45 37.6608 45 34.7451C45 31.8295 45 31.4319 45 30.2391C45 29.0463 44.7349 28.2511 44.4699 27.5885C44.2048 26.9258 43.8072 26.2632 43.1446 25.6005C42.4819 24.9379 41.9518 24.6728 41.1566 24.2752C40.494 24.0102 39.6988 23.8776 38.506 23.7451C37.3133 23.7451 37.0482 23.7451 34 23.7451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 29.0463C30.8193 29.0463 28.3012 31.5644 28.3012 34.7451C28.3012 37.9258 30.8193 40.4439 34 40.4439C37.1807 40.4439 39.6988 37.9258 39.6988 34.7451C39.6988 31.5644 37.1807 29.0463 34 29.0463ZM34 38.456C32.012 38.456 30.2892 36.8656 30.2892 34.7451C30.2892 32.7572 31.8795 31.0343 34 31.0343C35.988 31.0343 37.7108 32.6246 37.7108 34.7451C37.7108 36.7331 35.988 38.456 34 38.456Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8313 30.2391C40.5633 30.2391 41.1566 29.6457 41.1566 28.9138C41.1566 28.1818 40.5633 27.5885 39.8313 27.5885C39.0994 27.5885 38.506 28.1818 38.506 28.9138C38.506 29.6457 39.0994 30.2391 39.8313 30.2391Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6316_2939",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.3333 52.0784) rotate(-81.5289) scale(31.6789)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517936,
    stopColor: "#FF442C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF1ED2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_6316_2939",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.6667 16.7451) rotate(77.1957) scale(15.0407 41.7941)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.096473,
    stopColor: "#7000C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.408416,
    stopColor: "#9A00E2",
    stopOpacity: 0.723958
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975495,
    stopColor: "#AD00FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6316_2939"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18.7451,
    width: 32,
    height: 32,
    rx: 8.8,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaShare);
export default __webpack_public_path__ + "static/media/insta_share.d316ca8a26773291d6935eb15ab77907.svg";
export { ForwardRef as ReactComponent };